export default "__VITE_ASSET__DyPn8ICF__"